<div
  class="notification-box flex flex-col gap-[24px] justify-center items-center w-full min-w-full h-full min-h-full"
>
  <mat-icon>sentiment_very_dissatisfied</mat-icon>
  <h1>{{ '+INSTALLATIONS.INSTALLATION.INSTALLATION_STATUS.NO_RESPONSE' | translate }}</h1>
  <vi-text *ngIf="lastStatusChanged">
    {{ '+INSTALLATIONS.INSTALLATION.INSTALLATION_STATUS.LAST_RESPONSE' | translate }}
    {{ lastStatusChanged | date: 'short' }}
  </vi-text>
</div>
